import { Result, validatedApiCall } from '../../api';
import { APIValidationError } from '../../../types/api/api';

export const uploadCSV = async (
  formData: FormData,
): Promise<Result<any, APIValidationError>> => {
  return validatedApiCall<any>(`/api/config/upload-import`, {
    method: 'POST',
    auth: true,
    defaultContentType: true,
    body: formData,
  });
};
